export const GET_ALL_PROFILE_ROLES = "GET_ALL_PROFILE_ROLES";
export const GET_ADDITIONAL_INFORMATION = "GET_ADDITIONAL_INFORMATION";
export const RESET_DATA = "RESET_DATA";
